import { render, staticRenderFns } from "./HomeScreenSettings.vue?vue&type=template&id=047a9ca1"
import script from "./HomeScreenSettings.vue?vue&type=script&lang=js"
export * from "./HomeScreenSettings.vue?vue&type=script&lang=js"
import style0 from "./HomeScreenSettings.vue?vue&type=style&index=0&id=047a9ca1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports